// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"336":"d70a18e1","528":"9198a1f0","615":"6d3b2bf9","913":"f83b2212"}[chunkId] + ".css";
};